import React from "react";
import { Mail, X } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

const Contact = () => {
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  return (
    <div className={`${themeClass.bgColor} ${themeClass.baseText} min-h-screen`}>
      <div
        className={`max-w-3xl mx-auto px-6 py-12 rounded-xl shadow-lg transition-all duration-300 ${themeClass.overlayBg} ${themeClass.borderColor}`}
      >
        <Helmet>
          <title>Contact Us | BrowserArena</title>
          <meta
            name="description"
            content="Get in touch with the BrowserArena team for support, feedback, or collaboration."
          />
          <link rel="canonical" href={`https://browserarena.com/contact`} />
        </Helmet>

        <h1
          className={`text-3xl sm:text-4xl font-bold mb-6 text-center border-b-2 pb-2 ${themeClass.titleColor} ${themeClass.borderColor}`}
        >
          📬 Contact Us
        </h1>

        <p className={`text-center text-base sm:text-lg mb-8 ${themeClass.overlayText}`}>
          Have a question, feedback, or game suggestion? Reach out to us!
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-6 text-sm sm:text-base">
          {/* Email */}
          <a
            href="mailto:contact@browserarena.com"
            className={`flex items-center gap-3 px-5 py-3 rounded-md border transition-all ${themeClass.borderColor} ${themeClass.hoverBorder} ${themeClass.overlayText}`}
          >
            <Mail className="w-5 h-5" />
            admin@browserarena.com
          </a>

          {/* Twitter / X */}
          <a
            href="https://x.com/browserarena"
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-3 px-5 py-3 rounded-md border transition-all ${themeClass.borderColor} ${themeClass.hoverBorder} ${themeClass.overlayText}`}
          >
            <X className="w-5 h-5" />
            @browserarena
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
